import Vue from 'vue'

export default {
  SET_OBJECT(originalState, { name, data, state }) {
    Vue.set(state, name, data)
  },
  RESET_QUICK_ACTIONS(state) {
    state.quickActionGroups = []
    state.isSelectingQuickActionGroups = false
  },
  SET_MAINTENANCE_RETURN_FORECAST(state, payload) {
    state.maintenanceReturnForecast = payload
  },
  SET_ENQUEUED_CASHBACK_ADJUSTMENT_REPORT_STATE(state, payload) {
    state.hasEnqueuedCashbackAdjustmentReport = payload
  },
  SET_MAINTENANCE_MODULES(state, payload) {
    state.maintenanceModules = payload
  },
  SET_MAINTENANCE_ACCOUNT_IDS(state, payload) {
    state.maintenanceAccountIds = payload
  },
}
